module.exports = __webpack_public_path__ + "static/media/verify-otp-ic.178be2e2.svg";